// extracted by css-extract-rspack-plugin
export default {"wrapper":"_bcfbcd30","linksContainer":"_63a7e9b7"};